/**
 * Orders
 */

// React
import React, { FunctionComponent, useContext, useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { rulesOrderStatus } from '../../utils/rulesOrderStatus';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  cancelOrderAction,
  changeDeliveryTypeAction,
} from './actions';

// Selector
import { createStructuredSelector } from 'reselect';
import {
  getAllOrdersReportAction,
  getOrdersAction,
  updateAllOrderStatusActions,
  updateOrderStatusActions,
} from './actions';

import { Store } from '../../redux/reducers';

// Selector
import {
  makeSelectAllOrders,
  makeSelectCountList,
  makeSelectError,
  makeSelectLoading,
  makeSelectOrdersList,
} from './selectors';

// UI
import theme from '../../theme';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Select,
  TextField,
  Typography,
  InputLabel,
  FormHelperText,
  Card,
  CardHeader,
  CardContent,
} from '@material-ui/core';

import {
  MuiPickersUtilsProvider,
  DatePicker,
} from '@material-ui/pickers';

import JalaliUtils from '@date-io/jalaali';

// Icon
import Icon from '@mdi/react';
import {
  mdiAccountOutline,
  mdiCalendar,
  mdiCity,
  mdiClock,
  mdiClose,
  mdiKey,
  mdiPackageVariant,
  mdiPencilOutline,
  mdiPrinter,
  mdiStateMachine,
  mdiTruck,
  mdiTruckDeliveryOutline,
  mdiWarehouse,
  mdiKeyOutline,
} from '@mdi/js';

// Components
import RenderFilter from '../../utils/listDaynamicFilterHookForm';
import type { Filter } from '../../utils/listDaynamicFilter';
import List from './nonOrderPostList';
import Pagination from '@material-ui/lab/Pagination';
import CSV from './csv';
import ExelExport from './components/exelExport';

// Helper
import {
  checkMatchMedia,
  flattenObject,
  OrderTransportationType,
  removeEmptyValueObject,
  translate,
  convertPersianDigit2English,
} from '../../utils/helpers';

// Type
import {
  cancelPayload,
  Order,
  Payload,
  PayloadAllUpdate,
  PayloadChangeDeliveryType,
  Props,
  SelectorProps,
  Status,
} from './interfaces';
import { mdiCityVariantOutline } from '@mdi/js/commonjs/mdi';

// apis
import { GetAllOrdersRequestBuilder, GetOrdersCountRequestBuilder } from 'client-sdk/src/orders/orders';
import Client from 'client-sdk/src/client';
import handleError from '../../utils/handleError';
import { Response3PL } from './components/response3Pl';
import Modal from '../../components/Modal';
import ordersRepository from 'client-sdk/src/Repository/orders-repository';
import AlopeykRequest from './components/alopeykRequest';
import useQuery from '../../utils/hook/useQuery';
import { CreateBundleRequestBuilder } from 'client-sdk/src/bundles/bundle';
import handleNotfication from '../../utils/handleNotfication';
import Select3plModal from '../../components/Modal/select3pl';
import { PackIcon, SupplyingIcon , PickIcon } from './customIcon';
import { SnappBoxRequest } from './components/snappBoxRequest';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    paper: {},
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    inputHolder: {
      flex: 1,
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
      width: '100%',
    },
    pagination: {
      // marginTop: theme.spacing(1),
    },
    boxshadow: {
      position: 'relative',
      backgroundColor: 'white',
      padding: '14px',
      transform: 'translateY(-3px)',
      boxShadow: '-6px 6px 14px 0px rgba(0,0,0,0.15) !important',
    },
    cards: {
      position: 'relative',
      backgroundColor: 'white',
      padding: '14px',
    },
    iconHeader: {
      position: 'absolute',
      top: '5px',
      right: '5px',
    },
    cardContent: {
      marginTop: '-22px',
      display: 'flex',
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      borderRadius: '4px',
      padding: '10px 0',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    input: {
      display: 'flex',
      marginLeft: theme.spacing(1),
      flex: 2,
      '@media (max-width: 768px)': {
        fontSize: '12px',
      },
    },
    iconButton: {
      padding: 8,
      marginRight: '10px',
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    textArea: {
      width: '100%',
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      marginTop: '30px',
      top: '47px',
      right: 0,
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },
    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    paginationBox: {
      display: 'flex',
    },
    selectSize: {
      width: '35px',
    },
    subtitle: {
      fontSize: '14px',
      fontWeight: 500,
      color: '#8A8A8A',
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    // Cancel Dialog
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),

      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.error.main,
      },
    },
    cancelTitle: {
      fontSize: '18px',
      textAlign: 'center',
      fontWeight: 500,
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(2),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    icon: {
      marginRight: theme.spacing(1),
    },

    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '10px',
    },

    btnBox: {
      display: 'flex',
      flexDirection: 'row-reverse',
      width: '100%',
      '@media (max-width: 768px)': {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
      },
    },

    typeSection: {
      textAlign: 'center',
      marginBottom: theme.spacing(2),
      '& .MuiFormGroup-row': {
        justifyContent: 'space-around',
      },
    },
  })
);

type Inputs = {
  'customerNationalCode.contains': string;
};
interface driverInputs {
  vehicleType: string;
  driverName: string;
  driverId: number | string;
  deliveryDate: string;
  deliveryStartTime: string;
  deliveryEndTime: string;
  deliveryTime: string;
  bundleName: string;
}

const fetchTapinString = async selectedTapins => {
  try {
    const delayTime = 1000;
    const response = await ordersRepository.getOrderTapin({
      payload: { ids: selectedTapins },
    });
    const newWindow = window.open('about:blank', '_blank');
    newWindow?.document.open();
    newWindow?.document.write(response.data);
    setTimeout(() => newWindow?.print(), delayTime);
  } catch (err) {
    handleError(err);
  }
};

const fetchTapinKetabString = async selectedTapins => {
  try {
    const delayTime = 1000;
    const response = await ordersRepository.getOrderTapinKetab({
      payload: { ids: selectedTapins },
    });
    const newWindow = window.open('about:blank', '_blank');
    newWindow?.document.open();
    newWindow?.document.write(response.data);
    setTimeout(() => newWindow?.print(), delayTime);
  } catch (err) {
    handleError(err);
  }
};

const NonPostOrders: FunctionComponent<Props> = (props: Props) => {
  const [bundleDefaultValue, setBundleDefaultValue] = useState(false as boolean);
  const [showDragList, setShowDragList] = useState(false as boolean);
  const [confirmationDialog, setConfirmationDialog] = useState(
    false as boolean
  );
  const [bundleInfo, setBundleInfo] = useState<any | null>(null);

  const [bundleType, setBundleType] = useState("");
  const [searchId, setSearchId] = useState(null)

  const token = localStorage.getItem('token') || '';
  const [filters, setFilters] = useState([] as Filter[]);
  const { filtersValues, setFiltersValues } = useQuery({
    'parentId.specified': 'false',
    'deliveryType.in': ['COURIER', 'CHAPAR'],
    'deliveryLocationType.equals': 'IN_CUSTOMER_ADDRESS',
    page: 0,
    size: 100,
  } as any);
  const [openSize, setOpenSize] = React.useState(false as boolean);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const openMenu = Boolean(anchorEl);
  const [selectedStatus, setSelectedStatus] = useState([]);

  const [id, setId] = useState(-1 as number);
  const [openFilterBox, setOpenFilterBox] = React.useState(false);
  const [changeType, setChangeType] = useState(false as boolean);
  const [changeTransportationType, setChangeTransportationType] = useState(
    false as boolean
  );
  const [transportationValue, setTransportationValue] =
    useState<OrderTransportationType>('');
  const [sendType, setSendType] = useState<null | string>(null);
  const [confirmDialog, setConfirmDialog] = useState(false as boolean);
  const [openResponse3PL, setOpenResponse3PL] = useState(false as boolean);
  const [request3PLLoading, setRequest3PLLoading] = useState(false as boolean);
  const [request3PLError, setRequest3PLError] = useState(false as boolean);
  const [result3PLs, setResult3PLs] = useState([]);
  const [orderResults3PL, setOrderResults3PL] = useState([

    {

      id: 1234,
      status: 'SUCCESS',
      message: 'بارگذاری موفق',
    },
    {
      id: 1234,
      status: 'FAILED',
      message: 'بارگذاری ناموفق',
    },
    {
      id: 1234,
      status: 'SUCCESS',
      message: 'بارگذاری موفق',
    },
  ]);
  const [localItems, setLocalItems] = React.useState<Array<Order>>([]);
  const [cancelDescription, setCancelDescription] = useState('' as string);
  const [openConfirmCancel, setOpenConfirmCancel] = useState(false as boolean);
  const [openAlopeykRequest, setOpenAlopeykRequest] = useState(
    false as boolean
  );
  const [modal, setModal] = useState("");
  const [openRequestConfirmation, setOpenRequestConfirmation] = useState(
    false as boolean
  );
  const [previewState, setPreviewState] = useState('CANCELLED' as Status);
  const [loading, setLoading] = useState(false as boolean);
  const [allOrders, setAllOrders] = useState<Order[]>([]);

  const [selectedList, setSelectedList] = useState([] as Order[]);
  const [selectDriver, setSelectDriver] = useState(false as boolean);
  const [counts, setCounts] = useState({
    packaged: 0,
    resend: 0,
    returned: 0
  })
  const [numSelected, setNumSelected] = useState(0);
  const [selected, setSelected] = React.useState<string[]>([]);
  const [openAlertWarning, setOpenAlertWarning] = useState(false as boolean);
  const {
    register,
    handleSubmit,
    reset,
    errors,
    setValue,
    control,
    getValues,
  } = useForm<Inputs | driverInputs>();

  const {
    handleSubmit: handleSubmitHandler,
    errors: secondError,
    setValue: secondSetValue,
    control: secondControl,
    getValues: secondGetValue,
  } = useForm<Inputs | driverInputs>({
    defaultValues: {
      deliveryDate: new Date(),
      deliveryTime: ('15-20'),
      bundleName: ""
    }
  });

  const handleOpenSelectDriver = (data: driverInputs, type: string) => {
    setBundleType(type)
    if (bundleDefaultValue) {
      secondSetValue("bundleName", "test");
    }
    setSelectedList(data);
    setSelectDriver(true);
  };

  const handleCreateBundleWithName = async () => {
    try {
      const {
        deliveryDate,
        deliveryTime,
        bundleName
      } = bundleInfo!;
      setLoading(true);
      const payload = {
        deliveryDate,
        deliveryStartTime: convertPersianDigit2English(
          deliveryTime.substring(0, 2).concat(':00:00')
        ),
        deliveryEndTime: convertPersianDigit2English(
          deliveryTime.substring(3, 5).concat(':00:00')
        ),
        orderCount: selected.length,
        priority: 0,
        status: 'CREATED',
        orderIds: selected,
        name: bundleName
      };
      const creatBundleRequest = new CreateBundleRequestBuilder()
        .data(payload)
        .build();
      const client = new Client(token);
      await client.execute(creatBundleRequest);
      handleNotfication('مرسوله با موفقیت تخصیص یافت', 'success');
      setShowDragList(false);
      setSelectedList([]);
      setConfirmationDialog(false);
      setSelectDriver(false);
      getOrders();
      setupFilters();
      reset();
      // props.clearDriverListDispatch();
    } catch (err) {
      handleError(err.response);
    } finally {
      setLoading(false);
    }
  };


  const handleFormSubmit = (values: driverInputs) => {
    setBundleInfo(values);
    setConfirmationDialog(true);
  };
  const removeFilterHandler = (fieldName: any) => {
    const filtered = { ...filtersValues };
    delete filtered[fieldName];
    setFiltersValues(filtered);
  };

  const filterTranslator = (fieldName: string) => {
    const status = {
      customerName: 'نام سفارش دهنده',
      'customerName.equals': 'نام سفارش دهنده:',
      'customerName.contais': 'نام سفارش دهنده:',
      trackingCode: 'کد پیگیری',
      'trackingCode.equals': 'کد پیگیری',
      'trackingCode.contains': 'کد پیگیری',
      'id.equals': 'شناسه سفارش:',
      'id.contains': 'شناسه سفارش:',
      deliveryDate: 'زمان تحویل',
      'deliveryDate.equals': 'زمان تحویل:',
      'deliveryDate.contains': 'زمان تحویل:',
      status: 'وضعیت سفارش',
      'status.in': 'وضعیت سفارش:',
      'status.notIn': 'وضعیت سفارش:',
    };
    return status[fieldName];
  };
  const handleOpenChangeType = (id: number) => {
    setChangeType(true);
    setId(id);
  };

  const handleCloseChangeType = () => {
    setChangeType(false);
  };

  const handleOpenChangeTransportationType = (id: number) => {
    setTransportationValue('');
    setChangeTransportationType(true);
    setId(id);
  };

  const handleCloseChangeTransportationType = () => {
    setChangeTransportationType(false);
  };

  const handleCloseRequestConfirmation = () => {
    setOpenRequestConfirmation(false);
  };

  const handleChangeTransportationValue = (e: any) => {
    setTransportationValue(e.target.value);
  };

  const handleSelectType = (type: string) => {
    setSendType(type);
    setConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setSendType(null);
    setConfirmDialog(false);
  };

  const handleCloseSelectDriver = () => {
    setSelectDriver(false);
  };


  const handleCallback = () => {
    handleCloseConfirmDialog();
    handleCloseChangeType();
  };
  const modalCloseHandler = () => {
    setOpenResponse3PL(false);
    setChangeTransportationType(false);
    setOpenRequestConfirmation(false);
  };
  const handleSetOrders3PL = () => {
    if (transportationValue === 'SNAPP_BOX') {
      setModal("SNAPP_BOX")
    } else if (transportationValue === 'ALOPEYK') {
      setOpenAlopeykRequest(true);
    } else {
      setOrders3PL({
        body: { orderIds: [...id], tplCode: transportationValue },
        callback: () => {
          getOrders();
          setOpenResponse3PL(true);
        },
      });
    }
  };

  const setOrders3PL = async (actions: any) => {
    const payload = { ...actions };
    try {
      setRequest3PLLoading(true);
      const { response, callback } = await ordersRepository.setOrders3PL({
        payload,
      });
      setOrderResults3PL(response.data);
      callback && callback();
    } catch (error) {
      setRequest3PLError(error);
    } finally {
      setRequest3PLLoading(false);
    }
  };

  const get3PLs = async (actions: any) => {
    const payload = { ...actions };
    try {
      setRequest3PLLoading(true);
      const { response, callback } = await ordersRepository.get3PLs({
        payload,
      });
      setResult3PLs(response.data);
      callback && callback();
    } catch (error) {
      setRequest3PLError(error);
    } finally {
      setRequest3PLLoading(false);
    }
  };

  const handleChangeSendType = async () => {
    try {
      props.changeDeliverTypeDispatch({
        id,
        body: sendType?.toString(),
        filters: filtersValues,
        callback: handleCallback,
      });
    } catch (err) {
      //
    }
  };
  const handleCardClick = (name: any) => {
    switch (name) {
      case 'packaged':
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          'status.equals': 'PACKAGED',
          page: 0,
          size: 10,
        });
        break;
      case 'resend':
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          'status.equals': 'REQUESTED_TO_RESEND',
          page: 0,
          size: 10,
        });
        break;
      case 'returned':
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          'status.equals': 'REQUESTED_TO_RETURN',
          page: 0,
          size: 10,
        });
        break;
    }
  };
  const checkActiveCard = (name: string) => {
    const status = filtersValues['status.equals'] || "";
    switch (name) {
      case 'packaged':
        return (
          status == 'PACKAGED'
        );
      case 'resend':
        return status == 'REQUESTED_TO_RESEND'
      case 'returned':
        return status == 'REQUESTED_TO_RETURN'
      default:
        return false
    }
  };
  useEffect(() => {
    if (selected.length <= 1) {
      setBundleDefaultValue(true);
    }
    else {
      setBundleDefaultValue(false);
    }
  }, [selected])

  useEffect(() => {
    getOrders();
    get3PLs({ body: { "status.equals": "ACTIVE" } });
    setupFilters();
    const storedId = JSON.parse(localStorage.getItem('id'));
    setId(storedId);
  }, [filtersValues]); // eslint-disable-line react-hooks/exhaustive-deps


  useEffect(() => {
    if (bundleInfo !== null) {
      handleCreateBundleWithName();
    }
  }, [bundleInfo]);


  useEffect(() => {
    const storedId = JSON.parse(localStorage.getItem('id'));
    if (storedId) {
      localStorage.removeItem('id');
    }
    localStorage.setItem('id', JSON.stringify(selected));
  }, [id]);
  useEffect(() => {
    getOrdersCount()
  }, []);
  const classes = useStyles();
  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };

  const getOrders = async () => {
    props.ordersDispatch({
      ...filtersValues,
    });
  };

  const getOrdersCount = async () => {
    const resendCount = new GetOrdersCountRequestBuilder()
      .params(flattenObject({ ...filtersValues, 'status.equals': 'REQUESTED_TO_RESEND', }))
      .build();
    const packagedCount = new GetOrdersCountRequestBuilder()
      .params(flattenObject({ ...filtersValues, 'status.equals': 'PACKAGED', }))
      .build();
    const requestToReturn = new GetOrdersCountRequestBuilder()
      .params(flattenObject({ ...filtersValues, 'status.equals': 'REQUESTED_TO_RETURN', }))
      .build();
    const client = new Client(token);


    const resend = await client.execute(resendCount);
    const returned = await client.execute(requestToReturn);
    const packaged = await client.execute(packagedCount);
    setCounts({
      packaged: packaged.data,
      resend: resend.data,
      returned: returned.data
    })
  }

  const setupFilters = () => {
    setFilters([
      {
        type: 'input',
        id: 'customerCity.contains',
        label: 'شهر',
        icon: mdiCityVariantOutline,
      },
      {
        type: 'input',
        id: 'customerName.contains',
        label: 'نام سفارش‌دهنده',
        icon: mdiAccountOutline,
      },
      {
        type: 'input',
        id: 'id.equals',
        label: 'شناسه سفارش',
        icon: mdiPackageVariant,
      },
      {
        type: 'input',
        id: 'trackingCode.contains',
        label: 'کد پیگیری',
        icon: mdiKey,
      },
      {
        type: 'input',
        id: 'partnerName.contains',
        label: 'شرکت',
        icon: mdiCity,
      },
      {
        type: 'input',
        id: 'sourceName.contains',
        label: 'مبدا (انبار/مرکز)',
        icon: mdiWarehouse,
      },
      {
        type: 'date-picker-time',
        id: 'created.greaterThanOrEqual',
        label: 'تاریخ ثبت سفارش از ',
        icon: mdiCalendar,
      },
      {
        type: 'date-picker-time',
        id: 'created.lessThanOrEqual',
        label: 'تا تاریخ ثبت سفارش  ',
        icon: mdiCalendar,
      },
      {
        type: 'date-picker',
        id: 'deliveryDate.greaterThanOrEqual',
        label: 'تاریخ تحویل از ',
        icon: mdiCalendar,
      },
      {
        type: 'date-picker',
        id: 'deliveryDate.lessThanOrEqual',
        label: '  تا تاریخ تحویل ',
        icon: mdiCalendar,
      },
      {
        type: 'checkbox',
        id: 'status.in',
        label: 'وضعیت سفارش',
        icon: mdiStateMachine,
        data: [
          'ORDERED',
          'DELIVERED_TO_POST',
          'DELIVERED_TO_CENTER',
          'SUPPLIED_IN_CENTER',
          'PACKAGED',
          'BUNDLED',
          'LOADED',
          'ARRIVED',
          'DELIVERED',
          'NOT_DELIVERED',
          'RETURNED',
          'CANCELLED',
          'REGISTERED_IN_3PL',
          'REGISTERING_IN_3PL',
          'DELIVERED_TO_COURIER',
          'DELIVERED_TO_3PL_COURIER',
          'SCANNED',
          'REQUESTED_TO_RETURN',
          'RETURNED_TO_WAREHOUSE',
          'REQUESTED_TO_RESEND',
          'ASSIGNED',
        ],
        translateType: 'Order',
      },
      {
        type: 'select',
        id: 'bundleId.specified',
        label: 'وضعیت بسته',
        data: ['false', 'true'],
        translateType: 'OrderBundleStatus',
        icon: mdiPackageVariant,
      },
      {
        type: 'select',
        id: 'deliveryStartTime.equals',
        label: 'بازه تحویل',
        data: ['09:00:00', '15:00:00'],
        translateType: 'Order',
        icon: mdiClock,
      },
      {

        type: "checkbox",
        id: "tplType.in",
        label: "ناوگان حمل (3PL)",
        icon: mdiTruck,
        data: [
          'NONE',
          'LINK_EXPRESS',
          'ALOPEYK',
          'ALOPEYK_BUSINESS',
          'TAROFF_V2',
          'CHAPAR',
          'PETROEX',
          'SPEED',
          'DTSXP',
          'TAPIN_POST',
          'TAPIN_KETAB',
          'NEDEX',
          'SNAPP',
          'TAPSI',
          'SNAPP_BOX',
          'PARTNER_LOGISTIC',
          'RONAD_LOGISTIC',
          'TIPAX'
        ],
        translateType: 'TPL',
      },
      {
        type: 'checkbox',
        id: 'paymentType.in',
        label: 'شیوه پرداخت',
        icon: mdiStateMachine,
        data: ['COD', 'ONLINE'],
        translateType: 'COD',
      },
      {
        type: 'select',
        id: 'postPaid.equals',
        label: 'شیوه پرداخت کرایه',
        data: ['false', 'true'],
        translateType: 'postPaid',
        icon: mdiPackageVariant,
      },
      {
        type: 'select',
        id: 'deliveryType.in',
        label: 'درخواست ارسال',
        icon: mdiTruck,
        data: ['CHAPAR', 'COURIER', ['CHAPAR', 'COURIER']],
        translateType: 'deliveryStatus',
      },
      {
        type: 'select',
        id: 'orderType.equals',
        label: 'نوع سفارش',
        icon: mdiTruck,
        data: ['FROM_CENTER', 'WITHOUT_CENTER'],
        translateType: 'orderType',
      },
    ]);
  };
  let headCells = [];

  headCells = [
    { id: 'customerCity', label: 'آدرس', type: 'input' },
    { id: 'id', label: 'شناسه سفارش', type: 'input' },
    { id: 'centerName', label: 'مرکز/انبار', type: 'input' },
    {
      id: 'partnerName',
      label: 'شرکت',
      type: 'input',
    },
    {
      id: 'deliveryDate',
      label: 'تاریخ تحویل',
      type: 'date-picker',
    },
    {
      id: "orderTplType",
      label: "ناوگان حمل",
      translate: "TPL",
      checkbox: true,
      type: "checkbox",
      data: [
        "ALOPEYK",
        "LINK_EXPRESS",
        "TAROFF_V2",
        "CHAPAR",
        "PETROEX",
        "PISHRO_POST",
        "SPEED",
        "DTSXP",
        "TAPIN_POST",
        "TAPIN_KETAB",
        "NEDEX"
      ],
      translateType: "TPL",
      selectIcon: mdiPencilOutline,
      statusType: "orderTplType",
    },
    // {
    //   id: "packagedDate",
    //   label: "تاریخ تحویل به لجستیک",
    //   type: "date-picker",
    // },
    {
      id: 'weight',
      label: 'وزن',
      type: 'input',
    },
    {
      id: 'length',
      label: 'ابعاد',
      type: 'input',
    },
    {
      type: 'checkbox',
      id: 'paymentType',
      label: 'شیوه پرداخت',
      data: ['COD', 'ONLINE'],
      translateType: 'COD',
    },
    {
      id: 'status',
      label: 'وضعیت سفارش',
      translate: 'Order',
      checkbox: true,
      type: 'checkbox',
      data: [
        'SCANNED',
        'ORDERED',
        'DELIVERED_TO_POST',
        'DELIVERED_TO_CENTER',
        'SUPPLIED_IN_CENTER',
        'PACKAGED',
        'BUNDLED',
        'LOADED',
        'ARRIVED',
        'DELIVERED',
        'NOT_DELIVERED',
        'RETURNED',
        'CANCELLED',
        'REGISTERED_IN_3PL',
        'REGISTERING_IN_3PL',
        'DELIVERED_TO_COURIER',
        'DELIVERED_TO_3PL_COURIER',
        'REQUESTED_TO_RETURN',
        'RETURNED_TO_WAREHOUSE',
        'REQUESTED_TO_RESEND',
        'ASSIGNED',
      ],
      translateType: 'Order',
      statusModel: rulesOrderStatus,
      selectIcon: mdiPencilOutline,
      statusType: 'Order',
    },
  ];
  const head = { headCells };
  const handleClose = () => {
    setOpenSize(false);
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{ value: unknown }>) => {
    setFiltersValues({ ...filtersValues, page: 0, size: event.target.value });
  };

  const handleChangeOrderStatus = (val: { id: number; body: Status }) => {
    const { id, body } = val;
    setId(id);
    setPreviewState(body);
    if (body === 'NOT_DELIVERED' || body === 'RETURNED') {
      setCancelDescription('');
      setOpenConfirmCancel(true);
    } else {
      updateOrderStatus(id, body);
    }
  };

  const updateOrderStatus = (id: number, body: Status) => {
    props.updateOrderStatusDispatch({
      id,
      body: { status: body, description: cancelDescription },
      pagination: filtersValues,
    });
    onClose();
  };

  const onClose = () => {
    setOpenConfirmCancel(false);
  };

  const getAllOrdersCsv = async (payload: any) => {
    try {
      setLoading(true);
      const makeRequest = new GetAllOrdersRequestBuilder()
        .params(flattenObject({ ...payload, sort: 'created,desc' }))
        .build();
      const client = new Client(token);
      const { data } = await client.execute(makeRequest);
      setAllOrders(data);
    } catch (err) {
      handleError(err.response);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const groupStatusChange = (status: string) => {
    const checkList = new Array(...new Set(selectedStatus));
    if (checkList.length > 1) {
      setOpenAlertWarning(true);
      return;
    }
    const payload = {
      ids: selected,
      status,
      pagination: filtersValues,
    };
    props.updateAllOrderStatusDispatch(payload);
    setAnchorEl(false);
  };

  const selectItem = (id: string, status?: string) => {
    const selectedIndex = selected.indexOf(id);
    if (selectedIndex > -1) {
      const newList = [...selectedStatus];
      newList.splice(selectedIndex, 1);
      setSelectedStatus(newList);
      setSelected(selected.filter(el => el != id));
    } else {
      setSelectedStatus([...selectedStatus, status]);
      setSelected([...selected, id]);
    }
  };

  const handleSelectItem = (order: any) => {
    const selectedIndex = selectedList.map(el => el.id).indexOf(
      order.id
    );
    let newSelected: string[] = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(
        selectedList,
        props.ordersList.find((el: Order) => el.id === +order.id)
      );
      setSelectedList(newSelected);
      setNumSelected(newSelected.length)
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedList.slice(1));
      setSelectedList(newSelected);
      setNumSelected(newSelected.length)
    } else if (selectedIndex === selectedList.length - 1) {
      newSelected = newSelected.concat(selectedList.slice(0, -1));
      setSelectedList(newSelected);
      setNumSelected(newSelected.length)
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedList.slice(0, selectedIndex),
        selectedList.slice(selectedIndex + 1)
      );
      setSelectedList(newSelected);
      setNumSelected(newSelected.length)
    }
  };


  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelecteds = props.ordersList.map((n: any) => n.id);
      const newSelectedStatus = props.ordersList.map((n: any) => n.status);
      setSelected(newSelecteds);
      setSelectedStatus(newSelectedStatus);
      return;
    }

    setSelected([]);
    setSelectedStatus([]);
  };
  const handleCardClose = () => {
    delete filtersValues['status.equals'];
    setFiltersValues({
      ...removeEmptyValueObject(filtersValues),
      page: 0,
      size: 10,
    });
  };

  const snappboxClose = () => {
    setModal("")
    handleCloseRequestConfirmation()
    modalCloseHandler()
    getOrders()
  }
  return (
    <div className={classes.root}>
      <Grid container spacing={5}>
        <Grid container item xs={12} sm={6} alignItems="center">
          <Typography
            variant="h4"
            component="div"
            style={{ marginLeft: '20px', fontSize: '18px' }}
          >
            {'لیست سفارش‌ های لجستیک'}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <RenderFilter
            filters={filters}
            onFilter={(filtervalues: any) => {
              setFiltersValues({
                ...removeEmptyValueObject(filtervalues),
                'deliveryType.in': ['COURIER', 'CHAPAR'],
                'deliveryLocationType.equals': ['IN_CUSTOMER_ADDRESS'],
                page: 0,
                size: 100,
              });
            }}
            mainFiltersCount={1}
            baseFilter={{
              type: 'input',
              id: 'id.equals',
              placeholder: 'شناسه سفارش',
            }}
            autoFocus={true}
            filterValues={filtersValues}
          />
        </Grid>
        <Grid container xs={12} sm={12} md={12} spacing={2}>
          <Grid item md={6}>
            <Card
              className={
                checkActiveCard('packaged')
                  ? classes.boxshadow
                  : classes.cards
              }
            >
              <CardHeader
                action={
                  checkActiveCard('packaged') && (
                    <IconButton
                      aria-label="close"
                      onClick={handleCardClose}
                      className={classes.iconHeader}
                      data-cy="cardCloseBtn"
                    >
                      <Icon
                        path={mdiClose}
                        size={1}
                        style={{
                          color: '#Ffffff',
                          backgroundColor: '#FFA65A',
                          borderRadius: '3px',
                        }}
                      />
                    </IconButton>
                  )
                }
              />
              <CardContent className={classes.cardContent}>
                <IconButton
                  type="submit"
                  onClick={name => handleCardClick('packaged')}
                  aria-label="search"
                  style={{
                    backgroundColor: '#d6ebd4',
                    height: '30%',
                    width: '28%',
                    borderRadius: '4px',
                    margin: '-20px 0',
                  }}
                  data-cy="progressCardBtn"
                >
                  <PackIcon />
                </IconButton>
                <Grid
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    marginRight: '10px',
                  }}
                >
                  <Typography
                    variant="h6"
                    component="h6"
                    style={{ fontWeight: 600, marginTop: '-20px' }}
                    data-cy="processingCount"
                  >
                    {counts.packaged}
                  </Typography>
                  <Typography
                    style={{
                      fontSize: '16px',
                      marginBottom: '-20px',
                      fontWeight: 550,
                      color: '#666666',
                    }}
                  >
                    بسته بندی شده
                  </Typography>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          <Grid item md={6}>
            <Card
              className={
                checkActiveCard('resend')
                  ? classes.boxshadow
                  : classes.cards
              }
            >
              <CardHeader
                action={
                  checkActiveCard('resend') && (
                    <IconButton
                      aria-label="close"
                      onClick={handleCardClose}
                      className={classes.iconHeader}
                      data-cy="cardCloseBtn"
                    >
                      <Icon
                        path={mdiClose}
                        size={1}
                        style={{
                          color: '#Ffffff',
                          backgroundColor: '#FFA65A',
                          borderRadius: '3px',
                        }}
                      />
                    </IconButton>
                  )
                }
              />
              <CardContent className={classes.cardContent}>
                <IconButton
                  type="submit"
                  onClick={name => handleCardClick('resend')}
                  aria-label="search"
                  style={{
                    backgroundColor: '#fefe8e',
                    height: '30%',
                    width: '28%',
                    borderRadius: '4px',
                    margin: '-20px 0',
                  }}
                  data-cy="progressCardBtn"
                >
                  <SupplyingIcon />
                </IconButton>
                <Grid
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    marginRight: '10px',
                  }}
                >
                  <Typography
                    variant="h6"
                    component="h6"
                    style={{ fontWeight: 600, marginTop: '-20px' }}
                    data-cy="processingCount"
                  >
                    {counts.resend}
                  </Typography>
                  <Typography
                    style={{
                      fontSize: '16px',
                      marginBottom: '-20px',
                      fontWeight: 550,
                      color: '#666666',
                    }}
                  >
                    درخواست ارسال مجدد
                  </Typography>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          <Grid item md={6}>
            <Card
              className={
                checkActiveCard('returned')
                  ? classes.boxshadow
                  : classes.cards
              }
            >
              <CardHeader
                action={
                  checkActiveCard('returned') && (
                    <IconButton
                      aria-label="close"
                      onClick={handleCardClose}
                      className={classes.iconHeader}
                      data-cy="cardCloseBtn"
                    >
                      <Icon
                        path={mdiClose}
                        size={1}
                        style={{
                          color: '#Ffffff',
                          backgroundColor: '#FFA65A',
                          borderRadius: '3px',
                        }}
                      />
                    </IconButton>
                  )
                }
              />
              <CardContent className={classes.cardContent}>
                <IconButton
                  type="submit"
                  onClick={name => handleCardClick('returned')}
                  aria-label="search"
                  style={{
                    backgroundColor: '#e3daf7',
                    height: '30%',
                    width: '28%',
                    borderRadius: '4px',
                    margin: '-20px 0',
                  }}
                  data-cy="progressCardBtn"
                >
                  <PickIcon />
                </IconButton>
                <Grid
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    marginRight: '10px',
                  }}
                >
                  <Typography
                    variant="h6"
                    component="h6"
                    style={{ fontWeight: 600, marginTop: '-20px' }}
                    data-cy="processingCount"
                  >
                    {counts.returned}
                  </Typography>
                  <Typography
                    style={{
                      fontSize: '16px',
                      marginBottom: '-20px',
                      fontWeight: 550,
                      color: '#666666',
                    }}
                  >
                    درخواست بازگشت به انبار
                  </Typography>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Grid xs={12} sm={6} item container alignItems="center">
          {props.loading ? (
            ''
          ) : (
            <>
              {props.ordersList.length > 0 && (
                <>
                  <div className={classes.subtitle}>
                    {'تعداد کل سفارش‌ها:'}
                  </div>
                  <div>
                    &nbsp;
                    <b>{`${props.count}`}</b>
                  </div>
                </>
              )}
            </>
          )}
        </Grid>
        <Grid
          container
          item
          xs={12}
          md={6}
          direction="row-reverse"
          alignItems="center"
        >
          <div className={classes.btnBox}>
            <Button
              variant="contained"
              color="secondary"
              style={{ marginRight: '5px' }}
              onClick={() => props.history.push('/create-grouping-3PL')}
              // startIcon={<Icon path={mdiPlus} size={1} />}
              size={
                checkMatchMedia('(max-width: 1024px)') ? 'small' : 'large'
              }
            >
              {`3pl ثبت دسته‌جمعی `}
            </Button>
            {(selected.length <= 0 && (
              <CSV
                ordersDispatch={getAllOrdersCsv}
                data={allOrders}
                filtersValues={filtersValues}
                loading={loading}
              />
            )) ||
              (selected.length > 0 && (
                <Button
                  variant="contained"
                  color="secondary"
                  style={{ marginRight: '5px' }}
                  //BAHASH
                  onClick={() => handleOpenSelectDriver(localItems, "name")}

                  // startIcon={<Icon path={mdiPlus} size={1} />}
                  size={
                    checkMatchMedia('(max-width: 1024px)')
                      ? 'small'
                      : 'large'
                  }
                >
                  {`ایجاد مرسوله`}
                </Button>
              ))}
            <ExelExport
              data={allOrders}
              loading={loading}
              filtersValues={filtersValues}
              handleRequest={getAllOrdersCsv}
            />
            {selected.length >= 1 && (
              <React.Fragment>
                <Button
                  style={{ marginLeft: '5px' }}
                  variant="contained"
                  color="primary"
                  onClick={handleOpenMenu}
                  aria-controls="basic-menu"
                  aria-haspopup="true"
                  aria-expanded={openMenu ? 'true' : undefined}
                >
                  تغییر وضعیت گروهی
                </Button>
                <Menu
                  id="group-status"
                  aria-labelledby="group-status"
                  anchorEl={anchorEl}
                  open={openMenu}
                  onClose={handleCloseMenu}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                // transformOrigin={{
                //   vertical: 'top',
                //   horizontal: 'center',
                // }}
                >
                  {rulesOrderStatus[selectedStatus[0]]?.map(
                    (item: any, index: number) => (
                      <MenuItem
                        onClick={() => groupStatusChange(item)}
                      >
                        {translate(item, 'order')}
                      </MenuItem>
                    )
                  )}
                </Menu>
                <Button
                  style={{ marginLeft: '5px' }}
                  variant="contained"
                  color="primary"
                  onClick={() =>
                    handleOpenChangeTransportationType(id)
                  }
                >
                  انتخاب سرویس ارسال
                </Button>
                <IconButton
                  onClick={() => {
                    const win = window.open(
                      `/3pl-print-labels?id=${selected.join(',')}`,
                      '_blank'
                    )!;
                  }}
                  style={{
                    border: '2px solid ',
                    marginLeft: '5px',
                    borderRadius: '5px',
                  }}
                >
                  <Icon
                    path={mdiPrinter}
                    size={1}
                    color={'primary'}
                  />
                </IconButton>
                <IconButton
                  onClick={() => {
                    const win = window.open(
                      `/post-list?id=${selected.join(',')}`,
                      '_blank'
                    )!;
                  }}
                  style={{
                    border: '2px solid ',
                    marginLeft: '5px',
                    borderRadius: '5px',
                  }}
                >
                  <Icon
                    path={mdiPrinter}
                    size={1}
                    color={'secondary'}
                  />
                  <Typography variant="subtitle1">پست</Typography>
                </IconButton>
                <IconButton
                  onClick={() => {
                    fetchTapinString(selected.join(','));
                    //  const win = window.open(
                    //
                    //  )!;
                  }}
                  style={{
                    border: '2px solid ',
                    marginLeft: '5px',
                    borderRadius: '5px',
                  }}
                >
                  <Icon
                    path={mdiPrinter}
                    size={1}
                    color={'secondary'}
                  />
                  <Typography variant="subtitle1">تاپین</Typography>
                </IconButton>

                <IconButton
                  onClick={() => {
                    fetchTapinKetabString(selected.join(','));
                    //  const win = window.open(
                    //
                    //  )!;
                  }}
                  style={{
                    border: '2px solid ',
                    marginLeft: '5px',
                    borderRadius: '5px',
                  }}
                >
                  <Icon
                    path={mdiPrinter}
                    size={1}
                    color={'secondary'}
                  />
                  <Typography variant="subtitle1">
                    تاپین کتاب
                  </Typography>
                </IconButton>
              </React.Fragment>
            )}
          </div>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          {props.loading ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            <>
              {props.ordersList.length > 0 ? (
                <List
                  loading={props.loading}
                  data={props.ordersList}
                  handleOpenConfirmUpdateState={handleChangeOrderStatus}
                  handleOpenChangeType={handleOpenChangeType}
                  handleOpenChangeTransportationType={
                    handleOpenChangeTransportationType
                  }
                  selectedStatus={selectedStatus}
                  handleSelectedStatus={setSelectedStatus}
                  handleSelect={(id: number, status: string) => {
                    selectItem(id, status);
                    setId(id);
                  }}
                  selectedItems={selected}
                  selectAll={handleSelectAllClick}
                  head={head}
                  filterVal={filtersValues}
                  onFilterValue={(filtervalues: any) => {
                    setFiltersValues({
                      ...removeEmptyValueObject(filtervalues),
                      ...filtersValues,
                      page: 0,
                      size: 10,
                    });
                  }}
                  removeFilterHandler={removeFilterHandler}
                  filterLabelTranslator={filterTranslator}
                />
              ) : (
                <Typography variant="h3" component="div">
                  سفارشی موجود نیست
                </Typography>
              )}
            </>
          )}
        </Grid>
        <Grid item xs={12} sm={6}>
          {props.ordersList.length > 0 && (
            <FormControl
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <div style={{ marginLeft: '10px', color: '#8a8a8a' }}>
                {' '}
                تعداد نمایش در هر صفحه:
              </div>
              <Select
                open={openSize}
                onClose={handleClose}
                onOpen={() => setOpenSize(true)}
                value={filtersValues.size}
                onChange={handleChangeSizePage}
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
              </Select>
            </FormControl>
          )}
        </Grid>
        <Grid xs={12} sm={6} container item direction="row-reverse">
          {props.ordersList.length > 0 && (
            <Pagination
              className={classes.pagination}
              count={Math.ceil(props.count / filtersValues.size)}
              color="secondary"
              page={filtersValues.page + 1}
              onChange={handleChangePage}
            />
          )}
        </Grid>
      </Grid>

      <Dialog
        open={changeType}
        fullWidth
        onClose={handleCloseChangeType}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            <IconButton aria-label="close" onClick={handleCloseChangeType}>
              <Icon path={mdiClose} size={1} />
            </IconButton>
          </div>
          <div className={classes.editIcon}>
            <Icon
              path={mdiTruckDeliveryOutline}
              size={4}
              color={theme.palette.blue.main}
            />
          </div>

          <div className={classes.cancelTitle}>انتخاب نوع حمل</div>

          <div className={classes.typeSection}>
            <Button
              variant="contained"
              onClick={handleSelectType.bind(this, 'POST')}
              size="large"
            >
              پست
            </Button>
            {/* <Button
              variant="contained"
              style={{ marginRight: '1rem' }}
              onClick={handleSelectType.bind(this, 'DELIVER_IN_RONAD ')}
              size="large"
            >
              تحویل در انبار
            </Button> */}
            <Button
              variant="contained"
              style={{ marginRight: '1rem' }}
              onClick={handleSelectType.bind(this, 'VIP')}
              size="large"
            >
              ارسال ویژه
            </Button>
            <Button
              variant="contained"
              style={{ marginRight: '1rem' }}
              onClick={handleSelectType.bind(this, 'VVIP')}
              size="large"
            >
              ارسال فوری
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      <Select3plModal
        open={changeTransportationType}
        onClose={handleCloseChangeTransportationType}
        value={transportationValue}
        onChange={handleChangeTransportationValue}
        data={result3PLs}
        onSubmit={() => setOpenRequestConfirmation(true)}
      />

      <Dialog
        open={openRequestConfirmation}
        fullWidth
        onClose={handleCloseRequestConfirmation}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            <IconButton
              aria-label="close"
              onClick={handleCloseRequestConfirmation}
            >
              <Icon path={mdiClose} size={1} />
            </IconButton>
          </div>
          <div className={classes.editIcon}>
            <Icon
              path={mdiTruckDeliveryOutline}
              size={4}
              color={theme.palette.orange.main}
            />
          </div>

          <div style={{ margin: '50px 0' }} className={classes.cancelTitle}>
            آیا از ارسال درخواست به
            <strong>{translate(transportationValue, 'TPL')}</strong>
            مطمئن هستید ؟
          </div>
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid container spacing={1}>
            <Grid item xs={4}>
              <Button
                fullWidth
                autoFocus
                onClick={handleCloseRequestConfirmation}
                variant="outlined"
                size="large"
              >
                {`انصراف`}
              </Button>
            </Grid>
            <Grid item xs={8}>
              <Button
                fullWidth
                onClick={() => handleSetOrders3PL()}
                variant="contained"
                color="primary"
                size="large"
                disabled={request3PLLoading}
              >
                {`ارسال درخواست`}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Modal
        maxWidth="lg"
        fullScreen
        onClose={modalCloseHandler}
        open={openResponse3PL}
        title={
          <div>
            <h3 style={{ padding: '0 20px' }}>
              {'ارسال درخواست به '}
              <strong>{translate(transportationValue, 'TPL')}</strong>
            </h3>
          </div>
        }
        content={<Response3PL data={orderResults3PL} />}
      />

      <Modal
        maxWidth="lg"
        fullScreen
        onClose={() => setOpenAlopeykRequest(false)}
        open={openAlopeykRequest}
        title={
          <div>
            <h3
              style={{
                display: 'flex',
                marginBottom: 0,
                alignItems: 'center',
              }}
            >
              {`ارسال درخواست سفارش 
                ${id} 
                  به `}
              <strong>{translate(transportationValue, 'TPL')}</strong>
              <img
                style={{
                  width: '60px',
                  objectFit: 'contain',
                  margin: '0 20px',
                }}
                src={'/ALOPEYK.png'}
                alt={'alopeyk'}
              />
            </h3>
          </div>
        }
        content={
          <AlopeykRequest orderId={id} id={orderResults3PL[0]?.id} />
        }
      />

      <Modal
        maxWidth="lg"
        fullScreen
        onClose={snappboxClose}
        open={modal === "SNAPP_BOX"}
        title={
          <div>
            <h3
              style={{
                display: 'flex',
                marginBottom: 0,
                alignItems: 'center',
              }}
            >
              {`ارسال درخواست سفارش 
                ${id} 
                  به `}
              <strong>{translate(transportationValue, 'TPL')}</strong>
            </h3>
          </div>
        }
        content={
          <SnappBoxRequest order={props.ordersList.filter(el => el.id == id)[0]} orderId={id} onClose={snappboxClose} />
        }
      />

      <Dialog
        fullWidth
        open={confirmDialog}
        onClose={handleCloseConfirmDialog}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            <IconButton
              aria-label="close"
              onClick={handleCloseConfirmDialog}
            >
              <Icon path={mdiClose} size={1} />
            </IconButton>
          </div>
          <div className={classes.cancelTitle}>
            آیا از انتخاب {sendType && translate(sendType)} برای شیوه ارسال
            سفارش {id} مطمئنید؟
          </div>
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleCloseConfirmDialog}
                variant="contained"
                color="secondary"
                size="large"
              >
                {'خیر'}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                fullWidth
                variant="contained"
                onClick={handleChangeSendType}
                size="large"
              >
                {'بله'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openAlertWarning}
        onClose={() => setOpenAlertWarning(false)}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>امکان تغییر وضعیت سفارش وجود ندارد</DialogTitle>
        <DialogContent>
          وضعیت سفارش آیتم‌های انتخاب شده باید یکی باشد
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={() => setOpenAlertWarning(false)}
            variant="contained"
            color="primary"
          >
            {'متوجه شدم'}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openConfirmCancel}
        onClose={onClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {onClose ? (
              <IconButton aria-label="close" onClick={onClose}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.cancelIcon}>
            <Icon
              path={mdiClose}
              size={4}
              color={theme.palette.error.main}
            />
          </div>
          <div className={classes.cancelTitle}>
            {`از تغییر وضعیت سفارش با شناسه ${id} 
          به
          "${translate(previewState, 'order')}"
          مطمئن هستید؟`}
          </div>
          <TextField
            fullWidth
            id="description"
            name="description"
            className={classes.textArea}
            placeholder={`علت عدم تحویل...`}
            value={cancelDescription}
            onChange={e => setCancelDescription(e.target.value)}
          />
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid container spacing={1}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={() => setOpenConfirmCancel(false)}
                variant="contained"
                color="secondary"
                size="large"
              >
                {`خیر`}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                fullWidth
                onClick={() => updateOrderStatus(id, previewState)}
                variant="contained"
                size="large"
                disabled={!(cancelDescription.length > 0)}
              >
                {`بله`}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Dialog
        open={selectDriver}
        fullWidth
        onClose={handleCloseSelectDriver}
        aria-labelledby="responsive-dialog-title"
      >
        <form onSubmit={handleSubmitHandler(handleFormSubmit)}>
          <DialogContent style={{ marginBottom: '16px' }}>
            <div
              style={{
                position: 'absolute',
                left: '17px',
                zIndex: 10,
              }}
            >
              <IconButton
                aria-label="close"
                onClick={handleCloseSelectDriver}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            </div>
            <div className={classes.editIcon}>
              <Icon
                path={mdiTruckDeliveryOutline}
                size={4}
                color={theme.palette.blue.main}
              />
            </div>
            <Grid container spacing={3}>
              <Grid container item xs={12} sm={12} alignItems="flex-end">
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiKeyOutline}
                      size={1}
                      className={classes.icon}
                    />
                    <InputLabel className={classes.label} id="driverId">
                      نام باندل
                    </InputLabel>
                  </span>
                  <span className={classes.inputHolder}>
                    <Controller
                      style={{ width: '100%' }}
                      name="bundleName"
                      control={secondControl}
                      rules={{ required: true }}
                      as={<TextField type="text" value={secondGetValue().bundleName} />}

                    />
                  </span>
                </div>
              </Grid>
              <Grid container item xs={12} sm={6} alignItems="flex-end">
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiCalendar}
                      size={1}
                      className={classes.icon}
                    />
                    <InputLabel className={classes.label} id="deliveryDate">
                      تاریخ تحویل
                    </InputLabel>
                  </span>
                  <span className={classes.inputHolder}>
                    <Controller
                      style={{ width: '100%' }}
                      name="deliveryDate"
                      control={secondControl}
                      rules={{ required: true }}
                      disabled
                      render={() => (
                        <MuiPickersUtilsProvider
                          utils={JalaliUtils}
                          locale="fa"
                        >
                          <DatePicker
                            fullWidth
                            autoOk
                            variant="inline"
                            format="YYYY/MM/DD"
                            // okLabel="تأیید"
                            disablePast
                            // cancelLabel="لغو"
                            // clearLabel="پاک کردن"
                            value={secondGetValue().deliveryDate}
                            labelFunc={date =>
                              date?.isValid()
                                ? date.format('jYYYY/jMM/jDD')
                                : ''
                            }
                            onChange={value => {
                              value &&
                                secondSetValue(
                                  'deliveryDate',
                                  convertPersianDigit2English(
                                    value.format('YYYY-MM-DD')
                                  )
                                );
                            }}
                          />
                        </MuiPickersUtilsProvider>
                      )}
                    />
                    <FormHelperText error focused>
                      {secondError.deliveryDate &&
                        'تاریخ تحویل الزامی میباشد'}
                    </FormHelperText>
                  </span>
                </div>
              </Grid>
              <Grid container item xs={12} sm={6} alignItems="flex-end">
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiCalendar}
                      size={1}
                      className={classes.icon}
                    />
                    <InputLabel
                      className={classes.label}
                      id="deliveryStartTime"
                    >
                      ساعت آغار به کار
                    </InputLabel>
                  </span>
                  <span className={classes.inputHolder}>
                    <Controller
                      style={{ width: '100%' }}
                      name="deliveryTime"
                      control={secondControl}
                      rules={{ required: true }}
                      render={({ onChange, value }) => (
                        <Select
                          value={value}
                          style={{ width: '100%' }}
                          onChange={e => {
                            onChange(e);
                            e &&
                              secondSetValue('deliveryTime', e.target.value);
                          }}
                        >
                          <MenuItem value={'11-15'}>11-15</MenuItem>
                          <MenuItem value={'15-20'}>15-20</MenuItem>
                        </Select>
                      )}
                    />
                    <FormHelperText error focused>
                      {errors.deliveryStartTime &&
                        'ساعت آغاز به‌کار الزامی میباشد'}
                    </FormHelperText>
                  </span>
                </div>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Grid container spacing={2}>
              <Grid item xs={8}>
                <Button
                  fullWidth
                  autoFocus
                  onClick={handleCloseSelectDriver}
                  variant="contained"
                  color="secondary"
                  size="large"
                >
                  {`خیر`}
                </Button>
              </Grid>
              <Grid item xs={4}>
                <Button
                  fullWidth
                  disabled={loading}
                  type="submit"
                  variant="contained"
                  size="large"
                >
                  {`بله`}
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
};

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  ordersList: makeSelectOrdersList(),
  allOrders: makeSelectAllOrders(),
  count: makeSelectCountList(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    ordersDispatch: (payload: Payload) => dispatch(getOrdersAction(payload)),
    allOrdersDispatch: (payload: Payload) =>
      dispatch(getAllOrdersReportAction(payload)),
    updateOrderStatusDispatch: (payload: {
      id: number;
      body: string;
      pagination: object;
    }) => dispatch(updateOrderStatusActions(payload)),
    updateAllOrderStatusDispatch: (payload: PayloadAllUpdate) =>
      dispatch(updateAllOrderStatusActions(payload)),
    cancelOrderDispatch: (payload: cancelPayload) =>
      dispatch(cancelOrderAction(payload)),
    changeDeliverTypeDispatch: (payload: PayloadChangeDeliveryType) =>
      dispatch(changeDeliveryTypeAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
// @ts-ignore
export default compose(withConnect)(NonPostOrders);
